import React from 'react';
import PropTypes from 'prop-types';
import { NavDropdown, Navbar } from 'react-bootstrap';
import classNames from 'classnames';
import { ApexOnlineMenu } from 'apex-online-menu';
import uniqueId from 'lodash/uniqueId';
import AlignedImg from 'components/AlignedImg';
import Logo from './apex-logo.svg';
import styles from './styles.css';

const handleSelect = (callbacks) => (eventKey, event) => {
  if (eventKey in callbacks) {
    callbacks[eventKey](event);
  }
};

const getLegacyURL = () => {
  const { cookie } = document;
  const parts = cookie.split(';');
  const apexURL = parts.find((p) => p.includes('apexOnlineURL'));
  if (apexURL) {
    return apexURL.split('URL=')[1];
  }
  return null;
};

/* eslint-disable react/no-array-index-key */
const AppHeader = ({
  title,
  links,
  isActiveLink,
  onLogoutClick,
  showLogout,
  showSubMenu,
  menuItems,
  menuPermissions,
}) => (
  <div className="AppHeader">
    <div className={styles.header}>
      <AlignedImg
        align="left"
        src={Logo}
        alt="Apex Clearing"
        width="254"
        style={{ cursor: 'pointer' }}
      />
      <h4 className={styles.appName}>{title}</h4>
    </div>
    <ApexOnlineMenu
      items={menuItems}
      userPermissions={menuPermissions}
      legacyUrl={getLegacyURL()}
      showLogout={showLogout}
      logout={onLogoutClick}
    />

    {showSubMenu && (
      <Navbar className={styles.navbar} fluid onSelect={handleSelect({ logout: onLogoutClick })}>
        <ul className={classNames(styles.nav, 'nav navbar-nav')}>
          {links.map((link, index) =>
            // React-Bootstrap NavDropdown's are already wrapped in <li>'s. Don't wrap them in another <li>.
            link.type === NavDropdown ? (
              link
            ) : (
              <li className={classNames({ [styles.active]: isActiveLink(index) })} key={uniqueId('link-')}>
                {link}
              </li>
            ),
          )}
        </ul>
      </Navbar>
    )}
  </div>
);

AppHeader.propTypes = {
  isActiveLink: PropTypes.func,
  links: PropTypes.array,
  onLogoutClick: PropTypes.func,
  showLogout: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  showSubMenu: PropTypes.bool,
  menuItems: PropTypes.array,
  menuPermissions: PropTypes.any,
};

AppHeader.defaultProps = {
  isActiveLink: () => false,
  links: [],
  onLogoutClick: () => {},
  showLogout: false,
  showSubMenu: false,
  menuItems: [],
  menuPermissions: {},
};

export default AppHeader;



// WEBPACK FOOTER //
// ./src/components/AppHeader/index.js